import Dynamic from '../assets/skills/Dynamic.png';
import Intuitive from '../assets/skills/Intuitive.png';
import Responsive from '../assets/skills/Responsive.png';
import Designer from '../assets/skills/Designer.png';

const skills = [
     {
          ico: Dynamic,
          title: 'Dynamic',
          description: "Websites don't have to be static, I love making pages come to life.",
          delay: 0,
     },
     {
          ico: Intuitive,
          title: 'Intuitive',
          description: 'Strong preference for easy to use, intuitive UX/UI.',
          delay: 200,
     },
     {
          ico: Responsive,
          title: 'Responsive',
          description: 'My layouts will work on any device, big or small.',
          delay: 400,
     },
     {
          ico: Designer,
          title: 'Designer',
          description: 'A page or application needs a good design to be attractive.',
          delay: 600,
     },
];

export default skills;
